import React, { Component } from "react";
import "./colors.css";

class Colors extends Component {
  render() {
    let colors;
    if (this.props.colors) {
      colors = this.props.colors.map((c, i) => {
        return (
          <div
            className="palette-color"
            style={{ backgroundColor: `#${c.hexCode}` }}
            key={i}
          >
            <span className="color-code">{c.colorCode}</span>
          </div>
        );
      });
    }
    return <div>{colors}</div>;
  }
}

export default Colors;
